var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.employmentPhases.length > 0
        ? _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2)
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.employmentPhases, function(employmentPhase, i) {
        return _c("div", { staticClass: "grid-x grid-padding-x" }, [
          employmentPhase.id
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: employmentPhase.id,
                    expression: "employmentPhase.id"
                  }
                ],
                attrs: {
                  name: "employment_phase_specs[" + i + "][id]",
                  type: "hidden",
                  disabled: _vm.disabled,
                  required: ""
                },
                domProps: { value: employmentPhase.id },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(employmentPhase, "id", $event.target.value)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "cell pl-10 ml-10 pr-0 small-5 large-4" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: employmentPhase.title,
                  expression: "employmentPhase.title"
                }
              ],
              attrs: {
                name: "employment_phase_specs[" + i + "][title]",
                type: "text",
                disabled: _vm.disabled,
                required: ""
              },
              domProps: { value: employmentPhase.title },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(employmentPhase, "title", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell pl-4 ml-1 pr-0 small-3 large-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: employmentPhase.duration,
                  expression: "employmentPhase.duration"
                }
              ],
              attrs: {
                name: "employment_phase_specs[" + i + "][duration]",
                type: "text",
                disabled: _vm.disabled,
                required: ""
              },
              domProps: { value: employmentPhase.duration },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(employmentPhase, "duration", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell pl-4 ml-1 small-3 pr-0 large-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: employmentPhase.rate,
                  expression: "employmentPhase.rate"
                }
              ],
              attrs: {
                name: "employment_phase_specs[" + i + "][rate]",
                type: "number",
                step: "0.01",
                min: "0",
                disabled: _vm.disabled,
                required: ""
              },
              domProps: { value: employmentPhase.rate },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(employmentPhase, "rate", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell small-1 large-1" }, [
            !_vm.disabled
              ? _c(
                  "div",
                  {
                    staticClass: "remove-button",
                    on: {
                      click: function() {
                        return _vm.removeEmploymentPhase(i)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-minus-circle" })]
                )
              : _vm._e()
          ])
        ])
      }),
      _vm._v(" "),
      !_vm.disabled
        ? _c(
            "div",
            {
              staticClass: "add-button",
              on: { click: _vm.addEmploymentPhase }
            },
            [_c("i", { staticClass: "fas fa-plus-circle" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.employmentPhases.length === 0
        ? _c("input", {
            attrs: { name: "employment_phase_specs", value: "", type: "hidden" }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell pl-10 ml-10 small-5 large-4" }, [
      _c("label", [_vm._v("Employment Phases:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell pl-4 ml-1 small-3 large-3" }, [
      _c("label", [_vm._v("Duration:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell pl-4 ml-1 small-3 large-3" }, [
      _c("label", [_vm._v("Rate:")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bb7d1e8", { render: render, staticRenderFns: staticRenderFns })
  }
}